import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Auth } from "../../../commonPage";
import { Buttton } from "../../../components";
import { Commons } from "../../../utilities";
import { actionCommon } from "../../../redux/actions";
import { useAlert, useModal } from "../../../contexts";
import { MdAdminPanelSettings } from "react-icons/md";

const LoginPage = () => {
    const admin_access = JSON.parse(localStorage.getItem("admin_access"));
    const isAdminLoggedIn = admin_access?.token;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { showAlert } = useAlert();
    const { showModal, hideModal } = useModal();

    useEffect(() => {
        if (isAdminLoggedIn) {
            navigate("/");
        }
    }, [isAdminLoggedIn, navigate]);

    const loginSubmit = (credentials) => {
        dispatch(
            actionCommon.signIn(credentials, (error, response) => {
                if (error) {
                    let errorMessage = `${t('unexpected_error')}`;
                    let validationErrors = [];

                    if (error?.data) {
                        errorMessage =
                            error.data.error?.ErrorMessage ||
                            error.data.message ||
                            errorMessage;

                        validationErrors = error.data.error?.ValidationErrors || [];
                    }


                    if (validationErrors.length > 0) {
                        const validationDetails = validationErrors
                            .map((err) => `${err.Field}: ${err.Message}`)
                            .join("\n");

                        errorMessage += `\n\n\nDetails:\n${validationDetails}`;
                    }


                    if (error?.data?.statusCode === 400) {
                        showAlert("danger", errorMessage, `${t('Error')} !`);
                    } else {
                        showAlert("danger", errorMessage, `${t('Error')}: ${t('generic_error')}`);
                    }
                } else if (response) {
                    if (response.status === 200) {
                        localStorage.setItem(
                            "admin_access",
                            JSON.stringify(response.data.result)
                        );
                        showModal({
                            title: (
                                <div className="message-modal-title-blk">
                                    <MdAdminPanelSettings />
                                    <p className="exado-title-four">{t("success")}</p>
                                </div>
                            ),
                            bodyContent: <p>{t("admin.loginPage.success_login")} </p>,
                            autoClose: 5000,
                            footer: (
                                <Buttton.Buttton
                                    children={t("okay")}
                                    className="btn-solid-Aqua_Teal"
                                    onClick={hideModal}
                                />
                            ),
                            className: "message-modal",
                        });
                        navigate("/admin/dashboard");
                    }
                } else {
                }
            })
        );
    };

    if (isAdminLoggedIn) {
        return null;
    }

    return (
        <Auth.LoginCommonPage
            userType={Commons.userType.admin}
            loginSubmit={loginSubmit}
            subTitle={t("admin.loginPage.subTitle")}
            loginSide=""
            registerSide=""
            forgotSide=""
            closeNavigate="/admin"
        />
    );
};

export default LoginPage;
